import gql  from "graphql-tag";

const GET_POOL_QUIZZES = gql`
    query getPoolQuizzes (
        $poolId: String!
    ) {
        getPoolQuizzes (
            getPoolQuizzesInput: {
                poolId: $poolId
            }
        ){
            id
            title
            description
            image
            question {
                id
                orderNumber
            }
            timeLimitInSeconds
            orderNumber
            lessonType
            lessonContent
            poolId
        }
    }
`

export default GET_POOL_QUIZZES;